import React,{ useState, useEffect } from 'react';
import {AiOutlineUserAdd} from 'react-icons/ai';
import EditIconButton from "../../components/IconButtons/EditIconButton";
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../../contexts/ContextProvider';
import { useCentrosMutations } from '../../hooks';

import DataTable from 'react-data-table-component';
import { NewCentro } from '../../components';
import { getCentrosCompostajes } from '../../services/CentrosCompostaje';

const NavButton = ({ title, customFunc, icon, color, texto }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ backgroundColor: color}}
      className="relative text-xl  text-white rounded-lg p-3 hover:bg-light-gray"
    >
      <div className="flex flex-row justify-between items-center">
        <div>{icon}</div>
        <div><p className="text-xs ">{texto}</p></div>
      </div>
    
    </button>

  </TooltipComponent>
);

const CentrosCompostaje = () => {
  const { currentColor, handleClick, isClicked } = useStateContext();
  const {removeCentro} = useCentrosMutations();
  const [sucursalesData, setSucursalesData] = useState([]);
  const [laSucursal, setLaSucursal] = useState("");

    useEffect(()=>{
      const fetchData = async () => {
        const misSucursales = await getCentrosCompostajes();
        setSucursalesData(misSucursales);
      };
      fetchData();
    },[]);

  const handleEdit = (sucursalData) => {
    setLaSucursal(sucursalData);
    handleClick('nuevoCentro');
  };

  const handleEliminar = async (row) => {

    setSucursalesData((prevData) => prevData.filter((item) => item._id !== row._id));
    await removeCentro.mutateAsync(row._id);
    setSucursalesData((prevData) =>(prevData));
  };

  const handleRefreshDataTable = (opcion) => {
    if (opcion==="REFRESH"){
      const fetchData = async () => {
        const losFiados = await getCentrosCompostajes();
        setSucursalesData(losFiados);
      };
      fetchData();
    }

  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: 'white',
      },
    },
    headRow: {
      style: {
        backgroundColor: 'white',
        fontSize: 12,
        borderRadius: 8,
        fontWeight: '400',
        color: '#AEB2D7',
        borderWidth: 0,
        textAlign: 'center',
        headerStyles:{
          backgroundColor: '#F2F5FE',
          fontWeight: 'bold',
          color: '#2F336A',
        },
      },
    },
    rows: {
      style: {
        minHeight: '50px',
        margin: '4px 0px',
        backgroundColor: 'white',
        borderRadius: 8,
        fontSize: 10,
        rowStyles:{
          borderBottom: 1,
        }
      },
    },
  };

  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <EditIconButton onClick={() => handleEdit(row)} /> )
    },
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DeleteIconButton onClick={() => handleEliminar(row)} /> )
    },
    {
      name: 'Código',
      selector: row => row.codigo,
      sortable: true
    },
    {
      name: 'Centro de Compostaje',
      selector: row => row.nombreCentro,
      sortable: true
    },
    {
      name: 'Teléfono',
      selector: row => row.telefono,
      sortable: true
    },
    {
      name: 'Comuna',
      selector: row => row.nombreComuna,
      sortable: true
    },
    {
      name: 'Ciudad',
      selector: row => row.nombreCiudad,
      sortable: true
    },
    {
      name: 'Estado',
      selector: row => row.estado,
      sortable: true
    }
  ];

  return (
    <div className="m-2 md:m-10 mt-16 p-2 md:p-10 bg-white rounded-3xl">
        <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">

        <div  className="flex flex-col md:flex-row relative w-2/3">

          </div>
            <div className="flex flex-col justify-end">
              <NavButton title="Agregar Centro" customFunc={() => { setLaSucursal(''); handleClick('nuevoCentro')} } color={currentColor} icon={<AiOutlineUserAdd />} texto={'Nuevo Centro Compostaje'} />
            </div>
        </div>
        <DataTable
          columns={columns}
          data={sucursalesData}
          highlightOnHover
          pagination={true}
          striped
          className="border border-gray-300 rounded-lg shadow-sm"
          noHeader={true}
          selectableRowsHighlight
          customStyles={customStyles}
          noDataComponent={'No hay Centros de Compostaje creados'}
        />

      {isClicked.nuevoCentro && (<NewCentro vecinoData={laSucursal} onChangeVecino={handleRefreshDataTable}/>)}
    </div>
  );
};

export default CentrosCompostaje;